// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3nSTL","notes":"Notes_notes__lrFIn"};